import React from 'react';
import { Alert } from '@mui/material';
import { InvestorAllocationsResponse } from '../../../models/InvestmentEntity';

interface StatementAllocationWarningsProps {
  allocations: InvestorAllocationsResponse | null;
  hasNoEntities: boolean;
  isUnderAllocated: boolean;
}

/** The two allocation-coverage warnings shown above the generate button on StatementsSection. */
const StatementAllocationWarnings: React.FC<StatementAllocationWarningsProps> = ({
  allocations,
  hasNoEntities,
  isUnderAllocated,
}) => (
  <>
    {hasNoEntities && (
      <Alert severity="warning" sx={{ mb: 2 }}>
        This investor isn't allocated to any Investment Entity yet — a statement can't be generated
        until at least one allocation exists.
      </Alert>
    )}
    {isUnderAllocated && allocations && (
      <Alert severity="warning" sx={{ mb: 2 }}>
        This investor's entity allocations don't cover their full committed investment (
        {allocations.remainingAllocation.toLocaleString('en-AU', {
          style: 'currency',
          currency: 'AUD',
        })}{' '}
        unallocated). Statements will only reflect the entities they're allocated to.
      </Alert>
    )}
  </>
);

export default StatementAllocationWarnings;
